// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03346f77","455":"d6505a62","644":"314b432e","833":"b7f3d6cb"}[chunkId] + ".chunk.js";
};